export default __webpack_public_path__ + "static/media/linkedin.52f738cf.svg";